var path = 'src/app/components/administration/pawn-auction/pawn-auction-branches.template.html';
var html = "<section class=\"horizontal-padding\">\n  <branches-list detail-link=\"#!/admin/organization/pawn-auctions\"></branches-list>\n</section>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;